import React from "react";
import "./AllHotNewsSkeleton.css";

const AllHotNewsSkeleton = () => {
  // Render 3 skeleton articles to match your `.slice(0, 3)`
  return (
    <div className="allhotnews-skeleton-container">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="skeleton-article">
          <div className="skeleton-thumb shimmer"></div>
          <div className="skeleton-body">
            <div className="skeleton-line shimmer" style={{ width: "90%" }}></div>
            <div className="skeleton-line shimmer" style={{ width: "80%" }}></div>
            <div className="skeleton-line shimmer" style={{ width: "70%" }}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllHotNewsSkeleton;
